// JS actulaiza datos de el carrito de compras y los almacena en localstorage

js_cart_update()
function js_cart_update(){
    document.addEventListener('DOMContentLoaded', cartUpdate)
}

function cartUpdate() {
    const contents = document.querySelectorAll('.js-cart-update') 

    if (contents != null) {
        contents.forEach(content => {
            const buttons = content.querySelectorAll('.js-cart-update__button')
            const input = content.querySelector('.js-cart-update__input')
    
            buttons.forEach(button => {
                button.addEventListener('click', () => {
                    actualizarLine(content.dataset.id, input.value)
                })
            })
        })
    }

    function actualizarLine(id, num){
        $.ajax({
            url: "/cart/change",
            type: "post",
            data: {
                id: id,
                quantity: num
            },
            dataType: 'json',
            async: false,
            success: res => {
                localStorage.setItem('atom_cart', JSON.stringify(res))
            },
            error: err => {
                console.log(err)
            }
        }) 
    }
}
